
import "./Custom-Input.css";
import { Input } from "antd";

const CustomInput = ({
  className = "",
  type = "text",
  placeholder = "",
  value,
  onChange,
  onPressEnter,
  icon = null,
  style ={},
  ...props
}) => {
  return (

      <Input
        type={type}
        placeholder={placeholder}
        value={value}
        style={style}
         suffix={icon}
        className={`custom-input ${className}`} 
        onChange={onChange}
          onPressEnter={onPressEnter}
        {...props}
      />

  );
};

export default CustomInput;
